import cloner from '../utils/Cloner';
import httpErrorsHandler from './ErrorsHandlers/HttpErrorHandler';
const axios = require('axios').default;
class HttpClient {
  constructor() {
    this.runningRequests = 0;
  }
  setGlobalLoaderStateCallback(setIsLoaderShown) {
    this.setGolbalIsLoaderShown = setIsLoaderShown;
  }
  setLoaderStateCallback(setIsLoaderShown) {
    // todo, find a solution on how to inject the react state setter in the constructor
    this.setIsLoaderShown = setIsLoaderShown;
  }
  showLoader() {
    this.setIsLoaderShown(true);
  }
  hideLoader() {
    this.setIsLoaderShown(false);
  }
  setNavigationCallBack(callBack) {
    this.navigationCallBack = callBack;
  }
  setErrorCallBack(callBack) {
    this.errorCallBack = callBack;
  }
  request({
    method,
    url,
    data = null,
    config,
    onSuccess,
    onError = null,
    ignoreError = false,
    ignoreLoader = false
  }) {
    this.runningRequests++;
    !ignoreLoader && this.showLoader();
    const promise = this.createPromise(method, url, data, config);
    promise.then(onSuccess).catch(error => {
      if (ignoreError) onError(error);else httpErrorsHandler.handleError(error, this.navigationCallBack, this.errorCallBack, onError);
    }).finally(() => {
      this.runningRequests--;
      if (this.runningRequests === 0) {
        this.hideLoader();
      }
    });
  }
  async asyncRequest({
    method,
    url,
    data = null,
    config,
    onError = null,
    ignoreError = false,
    ignoreLoader = false
  }) {
    this.runningRequests++;
    !ignoreLoader && this.showLoader();
    try {
      const request = await this.createPromise(method, url, data, config);
      return request.data;
    } catch (error) {
      if (ignoreError) onError(error);else httpErrorsHandler.handleError(error, this.navigationCallBack, this.errorCallBack, onError);
    } finally {
      this.runningRequests--;
      if (this.runningRequests === 0) {
        this.hideLoader();
      }
    }
  }
  requestWithResolution({
    method,
    url,
    data,
    onSuccess,
    onError,
    ignoreError,
    config,
    isLoaderShown,
    setIsLoaderShown
  }) {
    this.runningRequests++;
    if (!ignoreError) this.showLoader();else if (setIsLoaderShown && !isLoaderShown) {
      setIsLoaderShown(true);
    }
    const promise = this.createPromise(method, url, data, config);
    promise.then(data => {
      onSuccess(data);
      return data;
    }).catch(error => {
      if (setIsLoaderShown) {
        setIsLoaderShown(false);
      }
      if (ignoreError && error.response.status >= 400 && error.response.status < 500) {
        onError(error);
      } else httpErrorsHandler.handleError(error, this.navigationCallBack, this.errorCallBack, onError);
    }).finally(() => {
      this.runningRequests--;
      if (this.runningRequests === 0 && setIsLoaderShown === undefined) {
        this.hideLoader();
      } else if (setIsLoaderShown) {
        setIsLoaderShown(false);
      }
    });
    return promise;
  }
  requestWithDelay({
    method,
    url,
    data,
    onSuccess,
    onError,
    config,
    ignoreError,
    delay
  }) {
    this.runningRequests++;
    this.showLoader();
    const promise = this.createPromise(method, url, data, config);
    setTimeout(() => {
      promise.then(onSuccess).catch(error => {
        if (ignoreError) onError(error);else httpErrorsHandler.handleError(error, this.navigationCallBack, this.errorCallBack, onError);
      }).finally(() => {
        this.runningRequests--;
        if (this.runningRequests === 0) {
          this.hideLoader();
        }
      });
    }, delay);
  }
  fetchInSequence({
    method,
    url,
    data,
    onSuccess,
    onError,
    ignoreError,
    config,
    isFirstStep,
    isLastStep
  }) {
    this.runningRequests++;
    if (isFirstStep) {
      this.showLoader();
      // setIsLoaderShown(true);
    }
    let abortSwitch = false;
    const promise = this.createPromise(method, url, data, config);
    promise.then(data => {
      onSuccess(data);
      return data;
    }).catch(error => {
      // this.runningRequests--;
      // setIsLoaderShown(false);
      // this.hideLoader()
      abortSwitch = true;
      if (ignoreError && error.response.status >= 400 && error.response.status < 500) {
        onError(error);
      } else httpErrorsHandler.handleError(error, this.navigationCallBack, this.errorCallBack, onError);
    }).finally(() => {
      this.runningRequests--;
      if (isLastStep && this.runningRequests === 0 || abortSwitch && this.runningRequests === 0) {
        this.hideLoader();
        // setIsLoaderShown(false);
      }
    });
    return promise;
  }
  // requestWithDelay({ method, url, data, config, onSuccess, onError, ignoreError, delay }) {
  //   this.runningRequests++;
  //   this.showLoader();
  //   const promise = this.createPromise(method, url, data, config);
  //   promise
  //     .then((data) => {
  //       setTimeout(
  //         () => {
  //           onSuccess(data);
  //         },

  //         delay
  //       );
  //     })
  //     .catch((error) => {
  //       if (ignoreError) onError(error);
  //       else httpErrorsHandler.handleError(error, this.navigationCallBack, this.errorCallBack, onError);
  //     })
  //     .finally(() => {
  //       setTimeout(() => {
  //         this.runningRequests--;
  //         if (this.runningRequests === 0) {
  //           this.hideLoader();
  //         }
  //       }, delay);
  //     });
  // }

  createPromise(method, url, data, config) {
    switch (method.toLowerCase()) {
      case 'get':
        const urlData = data ? '?' + new URLSearchParams(data).toString() : '';
        return axios.get(`${url}${urlData}`, config);
      case 'post':
      case 'patch':
      case 'put':
      case 'delete':
        const newConfig = cloner.clone(config);
        newConfig.method = method;
        newConfig.url = url;
        newConfig.data = data;
        return axios.request(newConfig);
      default:
        return;
    }
  }
}
const httpClient = new HttpClient();
export default httpClient;